import { Plane, Sparkles, UtensilsCrossed } from "lucide-react";
import { FadeUp, SectionIntro } from "../Reveal";
import { EditorialCard } from "../EditorialCard";
import { LuxButton } from "../LuxButton";
import { IMG } from "@/lib/images";

const SERVICES = [
  {
    image: IMG.dining,
    icon: UtensilsCrossed,
    category: "Gastronomy",
    title: "Fine dining access",
    description: "Reservations at the world's most sought-after restaurants.",
    to: "/concierge",
    testId: "service-card-dining",
  },
  {
    image: IMG.jet,
    icon: Plane,
    category: "Travel",
    title: "Private travel",
    description: "Bespoke journeys tailored entirely to your preferences.",
    to: "/concierge",
    testId: "service-card-travel",
  },
  {
    image: IMG.gala,
    icon: Sparkles,
    category: "Culture",
    title: "Exclusive events",
    description: "Access to gatherings and occasions beyond public reach.",
    to: "/events",
    testId: "service-card-events",
  },
];

export const Services = () => (
  <section data-testid="services-section" className="py-24 md:py-36">
    <SectionIntro
      eyebrow="Services"
      title={
        <>
          Curated access to life's <span className="gold-text italic">finest moments</span>
        </>
      }
      subtitle="From intimate dinners to global expeditions, we connect you to experiences that matter. Each service designed with precision."
    />
    <div className="snap-row no-scrollbar mt-16 flex gap-6 overflow-x-auto px-5 pb-2 lg:mx-auto lg:grid lg:max-w-[1280px] lg:grid-cols-3 lg:overflow-visible lg:px-12 lg:pb-0">
      {SERVICES.map((s, i) => (
        <EditorialCard key={s.title} {...s} delay={i * 0.12} />
      ))}
    </div>
    <FadeUp delay={0.15} className="mt-14 text-center">
      <LuxButton to="/concierge" testId="services-browse-all-button">
        Browse All Services
      </LuxButton>
    </FadeUp>
  </section>
);
